<!--<div class="page-load-animation"></div>-->
<elastic-route-handler></elastic-route-handler>

<!-- Everything related to Layout is found in core/layout/layout.component.ts -->
